import { render, staticRenderFns } from "./container-wrapper.vue?vue&type=template&id=74c2cdd6&scoped=true"
import script from "./container-wrapper.vue?vue&type=script&lang=js"
export * from "./container-wrapper.vue?vue&type=script&lang=js"
import style0 from "./container-wrapper.vue?vue&type=style&index=0&id=74c2cdd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2cdd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c2cdd6')) {
      api.createRecord('74c2cdd6', component.options)
    } else {
      api.reload('74c2cdd6', component.options)
    }
    module.hot.accept("./container-wrapper.vue?vue&type=template&id=74c2cdd6&scoped=true", function () {
      api.rerender('74c2cdd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/container-widget/container-wrapper.vue"
export default component.exports